// Types
import * as Types from '../types'
import { requestActionProps, requestGenerate } from '../../common'
import api from '../../../services/api'
import { callbackProps } from '../../../constants'

const actionGetGetGradeLevels = (
  callback?: (a: callbackProps) => void
): requestActionProps => ({
  type: requestGenerate(Types.SET_GRADE_LEVELS),
  api: api.getGradeLevels,
  callback,
});

export {
  actionGetGetGradeLevels,
};